import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { VivaWarningPopupComponent } from './viva-warning-popup.component';

@NgModule({
  declarations: [
    VivaWarningPopupComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    VivaWarningPopupComponent
  ]
})
export class  VivaWarningPopupModule { }
